import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=30b68799&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30b68799')) {
      api.createRecord('30b68799', component.options)
    } else {
      api.reload('30b68799', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=30b68799&", function () {
      api.rerender('30b68799', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2C07swQ0fYdp1/JS/comp/IncreaseNumber.vue"
export default component.exports